import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { useAuth } from "../../context/AuthContext";
import { SPEND } from "../../constants/creditsConfig";
import { hasNominatedToday, nominateCreator } from "../../services/creditsService";
import "./NominateCreatorButton.css";

export default function NominateCreatorButton({
  creatorId,
  creatorName = "this creator",
  variant = "default",
  className = "",
  onSuccess,
}) {
  const { currentUser, userProfile } = useAuth();
  const isCreator = userProfile?.role === "creator" || userProfile?.isCreator;
  const cost = isCreator ? SPEND.nomination.creator : SPEND.nomination.fan;

  const [nominatedToday, setNominatedToday] = useState(false);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!currentUser || !creatorId) return;
    hasNominatedToday(creatorId, currentUser.uid).then(setNominatedToday);
  }, [currentUser, creatorId]);

  if (!creatorId) return null;

  if (!currentUser) {
    return (
      <Link
        to="/welcome?auth=signin"
        className={`ncb ncb--${variant} ncb--signin ${className}`}
      >
        Sign in to nominate
      </Link>
    );
  }

  if (currentUser.uid === creatorId) return null;

  const handleNominate = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (nominatedToday || busy) return;
    setMessage("");
    setBusy(true);
    try {
      await nominateCreator(creatorId);
      setNominatedToday(true);
      setMessage(`Nominated ${creatorName.split(" ")[0]}!`);
      onSuccess?.();
    } catch (err) {
      setMessage(err.message || "Nomination failed.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={`ncb-wrap ${className}`}>
      <button
        type="button"
        className={`ncb ncb--${variant}${nominatedToday ? " ncb--done" : ""}`}
        onClick={handleNominate}
        disabled={nominatedToday || busy}
      >
        {busy
          ? "Sending…"
          : nominatedToday
            ? "Nominated today ✓"
            : `Nominate · ${cost} cr`}
      </button>
      {message && <span className="ncb-msg">{message}</span>}
    </div>
  );
}
